import request from 'api/request';
import {handleError} from 'helpers';

import {formValidation} from '../helpers';
import * as constants from '../helpers/constants';
import {taxActionTypes as types} from './actionTypes';
import {asyncLoad, asyncPost, asyncDelete, portalActions} from '.';

export const loadTaxCodes = () => dispatch =>
  asyncLoad({url: '/taxCodes', dispatch, title: 'Tax Codes'});

export const getTaxCodes = () => dispatch => {
  const url = `/TaxCodes`;
  return request({url})
    .then(data => {
      const results =
        data && data.data && data.data.results ? data.data.results : [];
      dispatch({
        type: types.LOAD_TAX_CODES_SUCCESS,
        taxCodes: results,
      });
    })
    .catch(error => {
      handleError('Unable to load tax codes', error, dispatch);
    });
};

export const loadTaxItems = (showInactive = false) => async (
  dispatch,
  getState,
) => {
  const response = await asyncLoad({
    dispatch,
    title: `${getState().portal.dictionary.Tax.value} item`,
    url: `/tax?showInactive=${showInactive}&fields=name,rate,description,taxId,isActive,items`,
  });

  dispatch({type: types.INITIAL_LOAD, payload: response.totalRows});

  return response;
};

export const saveTaxItem = taxItem => async (dispatch, getState) => {
  const formObject = formValidation.setupFormBody(taxItem, false);
  const taxKeyword = `${getState().portal.dictionary.Tax.value} Item`;
  let params = {};

  if (formObject.hasError) {
    handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  if (taxItem.rate.value && Number(taxItem.rate.value) > 100) {
    handleError('Rate must be less than 100.', null, dispatch);
    return null;
  }

  if (formObject.body.taxId) {
    params = {method: 'PUT'};
  }

  try {
    const result = await asyncPost({
      body: formObject.body,
      dispatch,
      params,
      successMessage: `The ${taxKeyword} has been ${
        taxItem.taxId ? 'updated' : 'added'
      } successfully.`,
      title: taxKeyword,
      url: `/tax${taxItem.taxId ? `/${taxItem.taxId.value}` : ''}`,
    });

    if (
      (taxItem.taxId &&
        Number(taxItem.taxId.value) ===
          getState().portal.portalSettings.DefaultTax.valueAsInt) ||
      (taxItem.isDefault && taxItem.isDefault.value)
    ) {
      await dispatch(
        portalActions.updatePortalSetting(
          constants.DEFAULT_TAX,
          taxItem.isDefault.value ? Number(result.data.taxId) : null,
        ),
      );
    }

    return result;
  } catch (err) {
    handleError('Error saving tax', err, dispatch);
    return null;
  }
};

export const deleteTaxItem = taxId => async (dispatch, getState) => {
  const taxKeyword = `${getState().portal.dictionary.Tax.value} Item`;

  if (taxId === getState().portal.portalSettings.DefaultTax.valueAsInt) {
    await dispatch(
      portalActions.updatePortalSetting(constants.DEFAULT_TAX, null),
    );
  }

  return asyncDelete({
    dispatch,
    successMessage: `The ${taxKeyword} has been deleted successfully.`,
    title: taxKeyword,
    url: `/tax/${taxId}`,
  });
};

export default getTaxCodes;



// WEBPACK FOOTER //
// ./src/actions/taxActions.js